import styles from './intro.module.css'

const Intro = () => {
    return (
        <figure className={styles.figure}>
            <img src='./images/company/intro/company_intro.jpg' alt="intro" />
            <article className={styles.txt}>
                <h1>제이소프트웨어는 </h1>
                <h3>서비스를 만들고, 기술의 경험을 나눕니다.</h3>
            </article>
        </figure>
    )
}

export default Intro;